import type { JobsListParams } from './jobs.api';

/**
 * Query keys for the ATS jobs list.
 *
 * A factory rather than inline arrays: two spellings of the same key are two
 * cache entries and two requests — the `fetchAiScoring` string-vs-number bug.
 * `all` is the invalidation handle every mutation targets, which replaces the
 * RTK tag.
 */
export const jobsKeys = {
  all: ['ats-jobs'] as const,
  lists: () => [...jobsKeys.all, 'list'] as const,
  list: (params: JobsListParams) => [...jobsKeys.lists(), params] as const,
};
